"use strict";
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceOracleProxyFactory = void 0;
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "address",
                name: "guardian_",
                type: "address",
            },
            {
                internalType: "address",
                name: "v1PriceOracle_",
                type: "address",
            },
            {
                internalType: "address",
                name: "tEthAddress_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cUsdcAddress_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cSaiAddress_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cDaiAddress_",
                type: "address",
            },
            {
                internalType: "address",
                name: "cUsdtAddress_",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        constant: true,
        inputs: [],
        name: "cDaiAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "cSaiAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "cUsdcAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "cUsdtAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "daiOracleKey",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                internalType: "contract TToken",
                name: "tToken",
                type: "address",
            },
        ],
        name: "getUnderlyingPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "guardian",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "isPriceOracle",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "saiPrice",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                internalType: "uint256",
                name: "price",
                type: "uint256",
            },
        ],
        name: "setSaiPrice",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "tEthAddress",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "usdcOracleKey",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "v1PriceOracle",
        outputs: [
            {
                internalType: "contract V1PriceOracleInterface",
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
];
const _bytecode = "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";
class PriceOracleProxyFactory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (args.length === 1) {
            super(_abi, _bytecode, args[0]);
        }
        else {
            super(...args);
        }
    }
    deploy(guardian_, v1PriceOracle_, tEthAddress_, cUsdcAddress_, cSaiAddress_, cDaiAddress_, cUsdtAddress_, overrides) {
        return super.deploy(guardian_, v1PriceOracle_, tEthAddress_, cUsdcAddress_, cSaiAddress_, cDaiAddress_, cUsdtAddress_, overrides || {});
    }
    getDeployTransaction(guardian_, v1PriceOracle_, tEthAddress_, cUsdcAddress_, cSaiAddress_, cDaiAddress_, cUsdtAddress_, overrides) {
        return super.getDeployTransaction(guardian_, v1PriceOracle_, tEthAddress_, cUsdcAddress_, cSaiAddress_, cDaiAddress_, cUsdtAddress_, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.PriceOracleProxyFactory = PriceOracleProxyFactory;
PriceOracleProxyFactory.bytecode = _bytecode;
PriceOracleProxyFactory.abi = _abi;
//# sourceMappingURL=PriceOracleProxyFactory.js.map